// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".dd48967774eecda9242ef9d45768937fe442a496.chunk.js";
};